/* global packItemsTemplateDownloadUrl packItemsImportUrl csrfToken */

import React, { useRef, useState } from 'react';

import Button from 'CommonComponents/Button';

import { useToast } from 'Hooks/useToast';

export default function PackItemsImportBar({ type }) {
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const toast = useToast();

    const handleDownloadTemplate = () => {
        if (packItemsTemplateDownloadUrl) {
            const finalUrl = `${packItemsTemplateDownloadUrl}?type=${type}`;
            window.open(finalUrl, '_blank');
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file || !packItemsImportUrl) return;

        setUploading(true);
        const formData = new FormData();
        formData.append('type', type);
        formData.append('import_file', file);

        fetch(packItemsImportUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                Accept: 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    toast.error(data.error);
                    return;
                }
                if (data.message) {
                    toast.success(data.message);
                }
            })
            .catch(() => {
                toast.error($t('Import failed.'));
            })
            .finally(() => {
                setUploading(false);
                e.target.value = '';
            });
    };

    return (
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <Button small variant="secondary" onClick={handleDownloadTemplate} type="button">
                {$t('Download template')}
            </Button>
            <input ref={fileInputRef} type="file" accept=".xlsx,.xls" className="tw-hidden" onChange={handleFileChange} aria-hidden="true" />
            <Button small variant="secondary" onClick={handleUploadClick} type="button" disabled={uploading}>
                {uploading ? $t('Uploading…') : $t('Upload from file')}
            </Button>
        </div>
    );
}
